import { tw } from '@/utils/tw';
import { default as BaseTagTheme } from 'base/components/Tag/theme';
import { merge } from 'lodash-es';

const Tag = tw.theme({
  extend: BaseTagTheme,
  variants: merge(BaseTagTheme.variants, {
    colors: {
      default: `border-cherry-blossom-100 bg-cherry-blossom-100 from-cherry-blossom-300 to-cherry-blossom-100 text-cherry-blossom-500 hover:border-cherry-blossom-300 hover:bg-cherry-blossom-300 hover:text-black focus:border-cannon-pink-400 focus:bg-gradient-to-b focus:text-black active:border-cannon-pink-400 active:bg-gradient-to-b active:text-black`,
      text: 'text-gray-600',
    },
    size: {
      small: `h-6 px-3 py-0 text-headline-2xs`,
      medium: `pt- h-10 px-3 py-0 pt-1`,
      large: `h-[54px] px-6 py-0 pt-1.5`,
      text: `leading-snug`,
    },
    variant: {
      default: 'border-3',
    },
  }),
});

export default Tag;
